export default __webpack_public_path__ + "static/comment-b6ca856f457937e36530f4593376db5c.jpg";